import { directive as vClickOutside } from "vue-clickaway";

// import bModalDirective from "bootstrap-vue/es/directives/modal/modal";

//marcel
import {
  VBModal
} from "bootstrap-vue";

/**
 * You can register global directives here and use them as a plugin in your main Vue instance
 */

const GlobalDirectives = {
  install(Vue) {
    Vue.directive("click-outside", vClickOutside);
    Vue.directive("b-modal", VBModal);
  }
};

export default GlobalDirectives;
